import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { ManufacturingScenarioTemplateManagementPage } from '@/areas/manufacturing-templates/ManufacturingScenarioTemplates/ManufacturingScenarioTemplateManagement/ManufacturingScenarioTemplateManagementPage';
import { canViewManufacturing } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

// One route, so the list stays mounted. Links to the list pass `templateId: undefined`, or the router keeps the id.
// Without an id the page selects the first template.
export const Route = createFileRoute('/_authenticated/manufacturing/_sidebar/templates/{-$templateId}')({
    staticData: { access: { permissions: canViewManufacturing }, chrome: 'home' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    // By name, not spread: an optional key doesn't fit the page's required `templateId: string | undefined`.
    const pathParams = Route.useParams();
    return <ManufacturingScenarioTemplateManagementPage templateId={pathParams.templateId} />;
}
